export const CODES = {
  admin: {
    menu: 'master.menu',
    health: 'admin.health',
    issues: 'admin.issues',
    dashboard: 'admin',
    workItems: 'voy.work-items',
    tenantSettings: 'admin.tenant-settings'
  },
  notifications: {
    dashboard: 'notifications-dashboard'
  },
  acc: {
    payments: 'acc.payments',
    paymentOrders: 'acc.paymentOrders',
    freightPayments: 'fre.freight-payments',
    freightPaymentsList: 'fre.freight-payments-list',
    bbase: 'acc.bbase'
  },
  workflows: {
    adminDashboard: 'adm.dashboard',
    tasks: 'wf.tasks',
    invoices: 'invoices',
    wfsets: 'wf.wfsets'
  },
  voy: {
    comp: 'voy.comp',
    calcDet: 'voy.calc.det',
    voyages: 'voy.voyages',
    tracker: 'voy.tracker',
    tceOverview: 'voy.tce-overview',
    unsyncedClaims: 'voy.unsynced-claims',
    accTracker: 'voy.acc-tracker',
    works: 'voy.works',
    opdash: 'voy.opdash',
    consCurves: 'voy.cons-curves',
    voyageSearch: 'voy.voyage-search',
    bunkeringsuppliesreport: 'voy.bunkeringsuppliesreport',
    itineraryofvesselreport: 'voy.itineraryofvesselreport',
    cargohistoryandanalysisreport: 'voy.cargohistoryandanalysisreport',
    cargoreport: 'voy.cargoreport',
    perfreport: 'voy.perfreport',
    pcreport: 'voy.pcreport',
    reportNoonDetails: 'voy.report.noon-details',
    reportVoyageDailyPerformance: 'voy.report.voyage-daily-performance',
    reportLatestNoonReports: 'voy.report.latest-noon-reports',
    dailyNoonPerformance: 'voy.daily-noon-performance',
    dailyNoonPerformancePerday: 'voy.daily-noon-performance-perday',
    stoppageListReport: 'voy.stoppage-list-report',
    consumptionsPerGradeReport: 'voy.consumptions-per-grade-report',
    consumptionsPerGradeReportDetailed: 'voy.consumptions-per-grade-report-detailed',
    weeklyLubricantsReport: 'voy.weekly-lubricants-report',
    daysAnalysisReport: 'voy.days-analysis-report',
    cargoStatisticsReport: 'voy.cargo-statistics-report',
    ciiReportVoyages: 'voy.cii-report-voyages',
    settings: 'voy.settings',
    portrestrictions: 'voy.portrestrictions',
    cptypes: 'voy.cptypes',
    indexValues: 'voy.index-values',
    porteventtypes: 'voy.porteventtypes',
    bjobs: 'voy.bjobs',
    tasklists: 'voy.tasklists',
    tasklistitems: 'voy.tasklistitems',
    tasklistitemcategories: 'voy.tasklistitemcategories',
    estimator: 'voy.estimator',
    estimatorNew: 'voy.estimator-new',
    hybridCalc: 'voy.hybrid-calc',
    marketIndices: 'voy.market-indices',
    tcin: 'voy.tcin'
  },
  bun: {
    bunkering: 'bun.bunkering',
    grades: 'bun.grades',
    offers: 'bun.offers',
    coqcategories: 'bun.coqcategories',
    coqisostandards: 'bun.coqisostandards',
    bunkeringportprices: 'bun.bunkeringportprices',
    proposedportcalls: 'bun.proposedportcalls'
  },
  fre: {
    freight: 'fre.freight',
    kpiDashboard: 'fre.kpi-dashboard',
    overview: 'fre.overview',
    monitoring: 'fre.monitoring'
  },
  pda: {
    portexpenses: 'pda.portexpenses',
    integrationnotifications: 'pda.integrationnotifications',
    voyagesintegration: 'pda.voyagesintegration',
    accountingcode: 'pda.accountingcode',
    expensegroups: 'pda.expensegroups',
    expensetypes: 'pda.expensetypes'
  },
  master: {
    vessels: 'master.vessels',
    tanks: 'master.tanks',
    vesselspecgroups: 'master.vesselspecgroups',
    vesselclasses: 'master.vesselclasses',
    licenseranks: 'master.licenseranks',
    dutyranks: 'master.dutyranks',
    payrollranks: 'master.payrollranks',
    vesseltypes: 'master.vesseltypes',
    companies: 'master.companies',
    fueltypes: 'master.fueltypes',
    ports: 'master.ports',
    cargotypes: 'master.cargotypes',
    cargogrades: 'master.cargogrades',
    flags: 'master.flags',
    persons: 'master.persons',
    ratings: 'master.ratings',
    companyRatings: 'master.company-ratings',
    customUsers: 'master.custom_users',
    departments: 'master.departments',
    deppos: 'master.deppos',
    roles: 'master.roles',
    usersettings: 'master.usersettings'
  },
  md: {
    incomecategories: 'md.incomecategories',
    incomereasons: 'md.incomereasons',
    expenseCategories: 'md.expense-categories',
    areas: 'md.areas',
    countries: 'md.countries',
    cities: 'md.cities',
    nationalities: 'md.nationalities',
    usercompanies: 'md.usercompanies',
    userdepartments: 'md.userdepartments',
    userpositions: 'md.userpositions',
    userRoles: 'md.user-roles'
  },
  ism: {
    drills: 'ism.drills',
    drillTypes: 'ism.drill-types'
  },
  pms: {
    defineComponentLibrary: 'pms.define-component-library',
    components: 'pms.components',
    componentNew: 'pms.component-new',
    componentEdit: 'pms.component-edit',
    spares: 'pms.spares',
    spareNew: 'pms.spare-new',
    spareEdit: 'pms.spare-edit',
    jobs: 'pms.jobs',
    jobNew: 'pms.job-new',
    jobEdit: 'pms.job-edit',
    vesselComponentLibrary: 'pms.vessel-component-library',
    vessels: 'pms.vessels',
    vesselAssign: 'pms.vessel-assign',
    vesselComponentNew: 'pms.vessel-component-new',
    vesselComponentEdit: 'pms.vessel-component-edit',
    vesselSpareNew: 'pms.vessel-spare-new',
    vesselSpareEdit: 'pms.vessel-spare-edit',
    vesselJobNew: 'pms.vessel-job-new',
    vesselJobEdit: 'pms.vessel-job-edit',
    vesselJobInstanceEdit: 'PMS.VesselJobInstances.Edit',
    mainLibraries: 'pms.main-libraries',
    fleetJobs: 'pms.fleet-jobs'
  },
  pur: {
    overview: 'pur.overview',
    requisitions: 'pur.requisitions',
    rfq: 'pur.rfq',
    purchaseOrders: 'pur.purchase-orders',
    catalogue: 'pur.catalogue',
    vendors: 'pur.vendors'
  }
} as const;

export type CodesValue = typeof CODES;

type DeepValues<T> = T extends string ? T : T extends Record<string, unknown> ? DeepValues<T[keyof T]> : never;

export type CodeString = DeepValues<typeof CODES>;
